import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const RMP_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.RMP>, RouteConfig> = {
  MISSING_PERSON: { basePath: config.router.servicePath, path: 'missing-person', isPrivate: true },
  MISSING_PERSON_EXTRACT: { basePath: config.router.servicePath, path: 'missing-person-extract', isPrivate: true },
};
